const transportCopy = {
  "es": {
    "Transporte / Flota": "Transporte / Flota",
    "Gestión de vehículos y gastos": "Gestión de vehículos y gastos",
    "Gasolina": "Gasolina",
    "Arreglo Mecánico": "Arreglo Mecánico",
    "Peaje (Toll)": "Peaje (Toll)",
    "Parqueo": "Parqueo",
    "Seguro": "Seguro",
    "Mantenimiento": "Mantenimiento",
    "Otro": "Otro",
    "Vehículo": "Vehículo",
    "Gasto": "Gasto",
    "Seguros por Vencer": "Seguros por Vencer",
    "Total Gastos": "Total Gastos",
    "Vehículos": "Vehículos",
    "Gastos": "Gastos",
    "Resumen": "Resumen",
    "No hay vehículos registrados": "No hay vehículos registrados",
    "+ Agregar Vehículo": "+ Agregar Vehículo",
    "Año:": "Año:",
    "Combustible:": "Combustible:",
    "Color:": "Color:",
    "Total Gastos:": "Total Gastos:",
    "Todos los vehículos": "Todos los vehículos",
    "Todos los tipos": "Todos los tipos",
    "Todas las empresas": "Todas las empresas",
    "Global (Sin empresa)": "Global (Sin empresa)",
    "Descripción": "Descripción",
    "Global": "Global",
    "Gastos por Tipo": "Gastos por Tipo",
    "Gastos por Vehículo": "Gastos por Vehículo",
    "Editar Vehículo": "Editar Vehículo",
    "Nuevo Vehículo": "Nuevo Vehículo",
    "Mantén al día tus vehículos y sus gastos.": "Mantén al día tus vehículos y sus gastos.",
    "Placa *": "Placa *",
    "Año *": "Año *",
    "Marca *": "Marca *",
    "Modelo *": "Modelo *",
    "Color": "Color",
    "Combustible": "Combustible",
    "Diesel": "Diesel",
    "Eléctrico": "Eléctrico",
    "Híbrido": "Híbrido",
    "VIN (Opcional)": "VIN (Opcional)",
    "Cancelar": "Cancelar",
    "Guardar": "Guardar",
    "Nuevo Gasto de Vehículo": "Nuevo Gasto de Vehículo",
    "Vehículo *": "Vehículo *",
    "-- Seleccionar vehículo --": "-- Seleccionar vehículo --",
    "Tipo de Gasto *": "Tipo de Gasto *",
    "Empresa (Opcional)": "Empresa (Opcional)",
    "Galones": "Galones",
    "$/Galón": "$/Galón",
    "Odómetro": "Odómetro",
    "No. Póliza": "No. Póliza",
    "Fecha Vencimiento": "Fecha Vencimiento",
    "Taller Mecánico": "Taller Mecánico",
    "Guardar Gasto": "Guardar Gasto",
    "Error al guardar vehículo": "Error al guardar vehículo",
    "Error al guardar gasto": "Error al guardar gasto",
    "¿Eliminar este vehículo y todos sus gastos?": "¿Eliminar este vehículo y todos sus gastos?",
    "¿Eliminar este gasto?": "¿Eliminar este gasto?",
    "Pregúntame por mantenimientos, gastos o documentos de tus vehículos.": "Pregúntame por mantenimientos, gastos o documentos de tus vehículos."
  },
  "en": {
    "Transporte / Flota": "Transport / Fleet",
    "Gestión de vehículos y gastos": "Vehicle and expense management",
    "Gasolina": "Gasoline",
    "Arreglo Mecánico": "Mechanical repair",
    "Peaje (Toll)": "Toll",
    "Parqueo": "Parking",
    "Seguro": "Insurance",
    "Mantenimiento": "Maintenance",
    "Otro": "Other",
    "Vehículo": "Vehicle",
    "Gasto": "Expense",
    "Seguros por Vencer": "Insurance expiring soon",
    "Total Gastos": "Total expenses",
    "Vehículos": "Vehicles",
    "Gastos": "Expenses",
    "Resumen": "Summary",
    "No hay vehículos registrados": "No vehicles registered",
    "+ Agregar Vehículo": "+ Add vehicle",
    "Año:": "Year:",
    "Combustible:": "Fuel:",
    "Color:": "Color:",
    "Total Gastos:": "Total expenses:",
    "Todos los vehículos": "All vehicles",
    "Todos los tipos": "All types",
    "Todas las empresas": "All companies",
    "Global (Sin empresa)": "Global (No company)",
    "Descripción": "Description",
    "Global": "Global",
    "Gastos por Tipo": "Expenses by type",
    "Gastos por Vehículo": "Expenses by vehicle",
    "Editar Vehículo": "Edit vehicle",
    "Nuevo Vehículo": "New vehicle",
    "Mantén al día tus vehículos y sus gastos.": "Keep your vehicles and expenses up to date.",
    "Placa *": "License plate *",
    "Año *": "Year *",
    "Marca *": "Make *",
    "Modelo *": "Model *",
    "Color": "Color",
    "Combustible": "Fuel",
    "Diesel": "Diesel",
    "Eléctrico": "Electric",
    "Híbrido": "Hybrid",
    "VIN (Opcional)": "VIN (Optional)",
    "Cancelar": "Cancel",
    "Guardar": "Save",
    "Nuevo Gasto de Vehículo": "New vehicle expense",
    "Vehículo *": "Vehicle *",
    "-- Seleccionar vehículo --": "-- Select vehicle --",
    "Tipo de Gasto *": "Expense type *",
    "Empresa (Opcional)": "Company (Optional)",
    "Galones": "Gallons",
    "$/Galón": "$/Gallon",
    "Odómetro": "Odometer",
    "No. Póliza": "Policy number",
    "Fecha Vencimiento": "Expiration date",
    "Taller Mecánico": "Repair shop",
    "Guardar Gasto": "Save expense",
    "Error al guardar vehículo": "Could not save vehicle",
    "Error al guardar gasto": "Could not save expense",
    "¿Eliminar este vehículo y todos sus gastos?": "Delete this vehicle and all its expenses?",
    "¿Eliminar este gasto?": "Delete this expense?",
    "Pregúntame por mantenimientos, gastos o documentos de tus vehículos.": "Ask me about maintenance, expenses or vehicle documents."
  },
  "pt": {
    "Transporte / Flota": "Transporte / Frota",
    "Gestión de vehículos y gastos": "Gestão de veículos e despesas",
    "Gasolina": "Gasolina",
    "Arreglo Mecánico": "Reparo mecânico",
    "Peaje (Toll)": "Pedágio",
    "Parqueo": "Estacionamento",
    "Seguro": "Seguro",
    "Mantenimiento": "Manutenção",
    "Otro": "Outro",
    "Vehículo": "Veículo",
    "Gasto": "Despesa",
    "Seguros por Vencer": "Seguros próximos do vencimento",
    "Total Gastos": "Total de despesas",
    "Vehículos": "Veículos",
    "Gastos": "Despesas",
    "Resumen": "Resumo",
    "No hay vehículos registrados": "Nenhum veículo cadastrado",
    "+ Agregar Vehículo": "+ Adicionar veículo",
    "Año:": "Ano:",
    "Combustible:": "Combustível:",
    "Color:": "Cor:",
    "Total Gastos:": "Total de despesas:",
    "Todos los vehículos": "Todos os veículos",
    "Todos los tipos": "Todos os tipos",
    "Todas las empresas": "Todas as empresas",
    "Global (Sin empresa)": "Global (Sem empresa)",
    "Descripción": "Descrição",
    "Global": "Global",
    "Gastos por Tipo": "Despesas por tipo",
    "Gastos por Vehículo": "Despesas por veículo",
    "Editar Vehículo": "Editar veículo",
    "Nuevo Vehículo": "Novo veículo",
    "Mantén al día tus vehículos y sus gastos.": "Mantenha seus veículos e despesas atualizados.",
    "Placa *": "Placa *",
    "Año *": "Ano *",
    "Marca *": "Marca *",
    "Modelo *": "Modelo *",
    "Color": "Cor",
    "Combustible": "Combustível",
    "Diesel": "Diesel",
    "Eléctrico": "Elétrico",
    "Híbrido": "Híbrido",
    "VIN (Opcional)": "VIN (Opcional)",
    "Cancelar": "Cancelar",
    "Guardar": "Salvar",
    "Nuevo Gasto de Vehículo": "Nova despesa do veículo",
    "Vehículo *": "Veículo *",
    "-- Seleccionar vehículo --": "-- Selecionar veículo --",
    "Tipo de Gasto *": "Tipo de despesa *",
    "Empresa (Opcional)": "Empresa (Opcional)",
    "Galones": "Galões",
    "$/Galón": "$/Galão",
    "Odómetro": "Odômetro",
    "No. Póliza": "Número da apólice",
    "Fecha Vencimiento": "Data de vencimento",
    "Taller Mecánico": "Oficina mecânica",
    "Guardar Gasto": "Salvar despesa",
    "Error al guardar vehículo": "Não foi possível salvar o veículo",
    "Error al guardar gasto": "Não foi possível salvar a despesa",
    "¿Eliminar este vehículo y todos sus gastos?": "Excluir este veículo e todas as suas despesas?",
    "¿Eliminar este gasto?": "Excluir esta despesa?",
    "Pregúntame por mantenimientos, gastos o documentos de tus vehículos.": "Pergunte-me sobre manutenção, despesas ou documentos dos seus veículos."
  },
  "fr": {
    "Transporte / Flota": "Transport / Flotte",
    "Gestión de vehículos y gastos": "Gestion des véhicules et des dépenses",
    "Gasolina": "Essence",
    "Arreglo Mecánico": "Réparation mécanique",
    "Peaje (Toll)": "Péage",
    "Parqueo": "Stationnement",
    "Seguro": "Assurance",
    "Mantenimiento": "Entretien",
    "Otro": "Autre",
    "Vehículo": "Véhicule",
    "Gasto": "Dépense",
    "Seguros por Vencer": "Assurances bientôt expirées",
    "Total Gastos": "Total des dépenses",
    "Vehículos": "Véhicules",
    "Gastos": "Dépenses",
    "Resumen": "Résumé",
    "No hay vehículos registrados": "Aucun véhicule enregistré",
    "+ Agregar Vehículo": "+ Ajouter un véhicule",
    "Año:": "Année :",
    "Combustible:": "Carburant :",
    "Color:": "Couleur :",
    "Total Gastos:": "Total des dépenses :",
    "Todos los vehículos": "Tous les véhicules",
    "Todos los tipos": "Tous les types",
    "Todas las empresas": "Toutes les entreprises",
    "Global (Sin empresa)": "Global (Sans entreprise)",
    "Descripción": "Description",
    "Global": "Global",
    "Gastos por Tipo": "Dépenses par type",
    "Gastos por Vehículo": "Dépenses par véhicule",
    "Editar Vehículo": "Modifier le véhicule",
    "Nuevo Vehículo": "Nouveau véhicule",
    "Mantén al día tus vehículos y sus gastos.": "Gardez vos véhicules et leurs dépenses à jour.",
    "Placa *": "Plaque d’immatriculation *",
    "Año *": "Année *",
    "Marca *": "Marque *",
    "Modelo *": "Modèle *",
    "Color": "Couleur",
    "Combustible": "Carburant",
    "Diesel": "Diesel",
    "Eléctrico": "Électrique",
    "Híbrido": "Hybride",
    "VIN (Opcional)": "VIN (Facultatif)",
    "Cancelar": "Annuler",
    "Guardar": "Enregistrer",
    "Nuevo Gasto de Vehículo": "Nouvelle dépense de véhicule",
    "Vehículo *": "Véhicule *",
    "-- Seleccionar vehículo --": "-- Sélectionner un véhicule --",
    "Tipo de Gasto *": "Type de dépense *",
    "Empresa (Opcional)": "Entreprise (Facultatif)",
    "Galones": "Gallons",
    "$/Galón": "$/Gallon",
    "Odómetro": "Compteur kilométrique",
    "No. Póliza": "Numéro de police",
    "Fecha Vencimiento": "Date d’expiration",
    "Taller Mecánico": "Atelier mécanique",
    "Guardar Gasto": "Enregistrer la dépense",
    "Error al guardar vehículo": "Impossible d’enregistrer le véhicule",
    "Error al guardar gasto": "Impossible d’enregistrer la dépense",
    "¿Eliminar este vehículo y todos sus gastos?": "Supprimer ce véhicule et toutes ses dépenses ?",
    "¿Eliminar este gasto?": "Supprimer cette dépense ?",
    "Pregúntame por mantenimientos, gastos o documentos de tus vehículos.": "Posez-moi des questions sur l’entretien, les dépenses ou les documents de vos véhicules."
  }
};
for (const [lang, month, repairs] of [['es','Este Mes','Reparaciones'],['en','This month','Repairs'],['pt','Este mês','Reparos'],['fr','Ce mois-ci','Réparations']]) { transportCopy[lang]['Este Mes']=month; transportCopy[lang]['Reparaciones']=repairs; }
export default transportCopy;
